// Ajustes → Tutoriais: lista os tutoriais existentes pra rever quando quiser e
// ligar/desligar a exibição automática na 1ª visita. Por padrão, depois de visto
// uma vez, cada tutorial se desativa — aqui dá pra reativar e rever.
import React from 'react';
import { Icon } from './icons';

const TUTORIAIS: Array<{ key: string; label: string; desc: string; auto: boolean; cta: string }> = [
  { key: 'onboarding', label: 'Como usar o Forjamente', desc: 'Boas-vindas, perfil, notificações e primeiros passos.', auto: true, cta: 'Rever tutorial' },
  { key: 'explore',    label: 'Explorar',                desc: 'Achar clubes, buscar pessoas e descobrir leitores.',   auto: true, cta: 'Rever tutorial' },
  { key: 'clube',      label: 'Clubes',                  desc: 'Como um clube funciona por dentro — estudo, marcos e stories. Reaparece quando você abrir um clube.', auto: false, cta: 'Reativar no próximo clube' },
];

export const TutoriaisScreen: React.FC<{
  profile: any;
  onReplay: (key: string) => void;
  onToggle: (key: string, enabled: boolean) => void;
  onBack: () => void;
}> = ({ profile, onReplay, onToggle, onBack }) => {
  const state = (profile && profile.tutorials_state) || {};
  return (
    <div className="scroll" style={{ paddingBottom: 60 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '40px 16px 4px' }}>
        <button onClick={onBack} aria-label="Voltar" style={{ width: 38, height: 38, borderRadius: '50%', background: 'var(--paper-2)', border: '1px solid var(--line)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon name="chevron-left" size={18} />
        </button>
        <div>
          <div className="mono" style={{ fontSize: 10, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--ink-3)' }}>Ajustes</div>
          <div className="serif" style={{ fontSize: 26, lineHeight: 1.1, marginTop: 2 }}>Tutoriais</div>
        </div>
      </div>
      <div style={{ padding: '6px 20px 0', fontSize: 13.5, color: 'var(--ink-3)', lineHeight: 1.5 }}>
        Reveja qualquer tutorial quando quiser. Eles aparecem sozinhos na 1ª visita de cada página — depois ficam desligados.
      </div>
      <div style={{ padding: '18px 16px 0', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {TUTORIAIS.map(t => {
          const st = state[t.key] || {};
          const seen = !!st.seen;
          const autoOn = st.enabled === true;
          return (
            <div key={t.key} style={{ background: 'var(--paper-2)', border: '1px solid var(--line)', borderRadius: 18, padding: 16 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--paper-3)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon name="sparkle" size={18} color="var(--ember)" />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="serif" style={{ fontSize: 17, color: 'var(--ink)' }}>{t.label}</div>
                  <div style={{ fontSize: 12.5, color: 'var(--ink-3)', marginTop: 2, lineHeight: 1.4 }}>{t.desc}</div>
                </div>
                {seen && <span className="mono" style={{ fontSize: 9, color: 'var(--ink-3)', letterSpacing: '0.1em', textTransform: 'uppercase', flexShrink: 0, marginTop: 2 }}>visto</span>}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 14 }}>
                <button onClick={() => onReplay(t.key)} style={{ flex: 1, padding: '11px', borderRadius: 11, background: 'var(--ink)', color: 'var(--paper)', fontSize: 13.5, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7 }}>
                  {t.cta}
                </button>
                {t.auto && (
                  <button onClick={() => onToggle(t.key, !autoOn)} style={{ padding: '11px 14px', borderRadius: 11, background: autoOn ? 'var(--ember-soft)' : 'var(--paper-3)', border: `1px solid ${autoOn ? 'var(--ember)' : 'var(--line)'}`, color: autoOn ? 'var(--ember)' : 'var(--ink-3)', fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {autoOn ? 'Auto: ligado' : 'Auto: desligado'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
